import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  updateData: null,
};

export const dataSlice = createSlice({
  name: "updateData",
  initialState,
  reducers: {
    updateUserData: (state, action) => {
      state.updateData = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateUserData } = dataSlice.actions;
export default dataSlice.reducer;
